<template>
  <v-layout justify-center wrap>
    <div v-if="error">{{ error }}</div>
    <v-flex md12 v-if="!error">
      <material-card
        color="success"
        title="Membros"
        text="Membros cadastrados na plataforma"
      >
        <v-layout>
          <v-flex sm12 md8 text-xs-left>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex sm12 md2 text-xs-right text-md-right>
            <v-btn
              class="mx-0 font-weight-light"
              color="primary"
              @click.prevent="newCustomer()"
            >
              <v-icon left dark>add</v-icon>Novo Cliente
            </v-btn>
          </v-flex>
          <v-flex sm12 md2 text-xs-right text-md-right>
            <v-btn
              class="mx-0 font-weight-light"
              color="secondary"
              @click.prevent="_export(users)"
            >
              <v-icon left>mdi-file-excel</v-icon>Exportar
            </v-btn>
          </v-flex>
        </v-layout>
        <v-progress-linear
          v-if="loading"
          height="2"
          v-slot:loading
          color="cyan"
          indeterminate
        ></v-progress-linear>
        <v-data-table
          dense
          :headers="headers"
          :items="users"
          :search="search"
          :loading="loading"
          no-data-text="Não há membros cadastrados"
          rows-per-page-text="Linhas por página"
          :pagination.sync="pagination"
        >
          <template slot="headerCell" slot-scope="{ header }">
            <span
              class="subheading font-weight-light text-success text--darken-3"
              v-text="header.text"
            />
          </template>
          <template slot="items" slot-scope="{ item }">
            <td>{{ item.created_at | formatarData }}</td>
            <td>{{ item.updated_at | formatarData }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.phone || "" }}</td>
            <td>{{ item.status || "" }}</td>
            <td class="text-xs-right">
              <v-icon
                left
                v-if="
                  item.card_default &&
                  item.card_default !== '' &&
                  (item.payment_type === 'credit_card' ||
                    item.payment_type === 'credit-card')
                "
                >mdi-credit-card-plus</v-icon
              >
              <v-icon
                left
                v-else-if="item.payment_type && item.payment_type === 'boleto'"
                >mdi-barcode</v-icon
              >
              <v-icon
                left
                v-else-if="item.payment_type && item.payment_type === 'pix'"
                >qr_code_2</v-icon
              >
            </td>
            <td class="text-xs-right">
              <a
                :href="
                  encodeURI(
                    'https://web.whatsapp.com/send?phone=' +
                      formatWhatsappPhone(item.phone) +
                      '&text=Olá ' +
                      item.name.split(' ')[0] +
                      ', *seja bem-vindo(a) a Enercred!* ⚡ Parabéns por entrar para o mundo da economia e sustentabilidade. Meu nome é *Caio* e estou aqui para te ajudar.',
                  )
                "
                target="_blank"
              >
                <v-icon>mdi-whatsapp</v-icon>
              </a>
            </td>
            <!-- <td>{{ item.card_default }}</td> -->
            <td>
              <v-icon @click.prevent="customerSelected(item)"
                >visibility</v-icon
              >
            </td>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning"
              >Sua busca para "{{ search }}" não retornou resultados.</v-alert
            >
          </template>
          <template v-slot:pageText="items"
            >Linhas {{ items.pageStart }} - {{ items.pageStop }} de
            {{ items.itemsLength }}</template
          >
        </v-data-table>
      </material-card>
    </v-flex>
  </v-layout>
  <!-- </v-container> -->
</template>
<script>
import moment from "moment";
import { eventBus } from "../../main";
import XLSX from "xlsx";

export default {
  props: ["users", "error"],
  data: () => ({
    search: "",
    loading: false,
    data: [
      [
        "indice",
        "nome",
        "email",
        "telefone",
        "data de criacao",
        "ultima atualizacao",
        "assinado em",
        "endereco",
        "cidade",
        "cep",
        "Documento",
        "CPF",
        "ID do usuário",
        "Data de Nascimento",
        "Sexo",
        "Estado Civil",
        "Comunhao de Bens",
        "Status",
        "Profissao",
        "Saldo de Indicação",
        "Recebeu por indicações",
        "metodo de pagamento",
        "possui cartao?",
        "media de consumo",
      ],
    ],
    headers: [
      {
        sortable: true,
        text: "Criado",
        value: "created_at",
      },
      {
        sortable: true,
        text: "Atualizado",
        value: "updated_at",
      },
      {
        sortable: true,
        text: "Name",
        value: "name",
      },
      {
        sortable: true,
        text: "E-mail",
        value: "email",
      },
      {
        sortable: true,
        text: "Telefone",
        value: "phone",
      },
      {
        sortable: true,
        text: "Status",
        value: "status",
      },
      {
        sortable: false,
        text: "Met. Pag.",
        value: "payment_type",
      },
      {
        sortable: false,
        text: "Whats",
        value: "whatsapp",
      },
      // {
      //     sortable: true,
      //     text: 'card_default',
      //     value: 'item.card_default',
      //     align: 'right'
      // },

      {
        text: "   ",
        sortable: false,
        name: "edit",
      },
    ],
    pagination: {
      sortBy: "item.item.updated_at",
      rowsPerPage: 10,
    },
  }),
  filters: {
    formatarData: function (value) {
      // console.log('value: ', value)
      if (!value) return "-";
      let timestamp = value; // firebase data
      let myDate = new Date(); // date object
      myDate = new Date(timestamp.seconds * 1000); // date object
      // console.log(timestamp.valueOf().seconds)
      // if (timestamp.valueOf().seconds) {
      //   // myDate = timestamp.toDate()
      //   myDate = new Date(timestamp.seconds * 1000) // date object
      // } else if (timestamp.valueOf()._seconds) {
      //   myDate = new Date(timestamp._seconds * 1000) // date object
      // } else {
      //   return "-"
      // }
      return moment(myDate.toISOString()).format("DD/MM/YYYY");
    },
    formatDate: function (value) {
      // console.log('value: ', value)
      if (!value) return "";
      if (typeof value === "string") {
        return moment(value).format("DD/MM/YYYY");
      }
      let timestamp = value; // firebase data
      let myDate = new Date(timestamp._seconds * 1000); // date object
      if (typeof myDate !== "object") {
        return "";
      }
      return moment(myDate.toISOString().substr(0, 10)).format("DD/MM/YYYY");
    },
  },
  methods: {
    customerSelected(customer) {
      this.loading = true;
      eventBus.$emit("userSelected", customer);
      this.$router.push({
        path: "/membro/" + customer.customer_id,
        params: { id: customer.customer_id },
      });
    },
    async newCustomer() {
      this.$router.push({ path: "/membro/" });
    },
    async _export(users) {
      /* convert state to workbook */
      users.forEach((item, index) => {
        item.id = index;
        // const lead = getLead(item.email)
        // const average = lead.data().average_consumption
        var address = "";
        if (item.address) {
          address = item.address.address;
          if (item.address.address_number) {
            address = address + ", " + item.address.address_number;
          }
          if (item.address.address_complement) {
            address = address + ", " + item.address.address_complement;
          }
          if (item.address.district) {
            address = address + " - " + item.address.district;
          }
          if (item.address.city) {
            address = address + " - " + item.address.city;
          }
          if (item.address.state) {
            address = address + " - " + item.address.state.initials || "";
          }
          if (item.address.city) {
            address = address + " CEP: " + item.address.postal_code;
          }
        }

        this.data.push([
          index + 1,
          item.name || "",
          item.email || "",
          item.phone || "",
          this.formatarData(item.created_at),
          this.formatarData(item.updated_at),
          item.signedcontract_at
            ? this.formatarData(item.signedcontract_at)
            : this.formatarData(item.updated_at),
          address,
          item.address && item.address.city ? item.address.city : "",
          item.address && item.address.postal_code
            ? item.address.postal_code
            : "",
          item.ID_Document || "",
          item.cpf || "",
          item.customer_id || "",
          this.formatarData(item.date_of_birth),
          item.gender || "",
          item.marital_status || "",
          item.marital_type || "",
          item.status || "",
          item.profissão || "",
          item.referral_balance || 0,
          item.referral_rewards || 0,
          item.payment_type === "boleto" ? "boleto" : "cartão de crédito",
          item.card_default ? "Sim" : "Não",
          item.average_consumption || "",
        ]);
        // console.log('data: ', this.data)
      });
      const ws = XLSX.utils.aoa_to_sheet(this.data);
      const wb = XLSX.utils.book_new();

      const file = "users_" + this.formatFileName(new Date());
      // XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
      XLSX.utils.book_append_sheet(wb, ws, file);
      /* generate file and send to client */
      XLSX.writeFile(wb, file + ".xlsx");
    },
    formatFileName(value) {
      if (!value) return "";
      const year = value.getYear();
      const month = value.getMonth() + 1;
      const day = value.getDay();
      const hour = value.getHours();
      const minute = value.getMinutes();
      return day + "" + month + "" + year + "" + hour + "" + minute;
    },
    formatarData: function (value) {
      if (!value) return "-";
      if (typeof value === "string") {
        return moment(value).format("DD/MM/YYYY");
      }
      let timestamp = value; // firebase data

      let myDate = new Date(); // date object
      if (timestamp.seconds) {
        // console.log('seconds: ', timestamp.valueOf().seconds)
        // myDate = timestamp.toDate()
        myDate = new Date(timestamp.seconds * 1000);
      } else if (timestamp.valueOf()._seconds) {
        // myDate = timestamp.toDate()
        myDate = new Date(timestamp._seconds * 1000); // date object
      } else {
        return "-";
      }
      return moment(myDate.toISOString()).format("DD/MM/YYYY");
    },
    formatWhatsappPhone(phone) {
      let newphone = phone.replace(/\D/g, "");
      if (newphone.substring(0, 2) !== "55") {
        newphone = "55" + newphone;
      }
      return newphone;
    },
  },
};
</script>
